import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import { v1 as uuid, } from 'uuid'
import moment from 'moment'

import tripIdFromName from 'lib/tripIdFromName'
import AddTrip from 'components/AddTrip'

class AddTripScene extends Component {
  static propTypes = {
    existingTripIds: PropTypes.arrayOf(PropTypes.string),
    actions: PropTypes.shape({
      createTrip: PropTypes.func.isRequired,
      navEditTrip: PropTypes.func.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    existingTripIds: [],
  }

  state = {
    canCreate: false,
    tripId: '',
    name: '',
    nameAlreadyInUse: false,
    startDate: moment(new Date()).format('YYYY-MM-DD'),
    startDateInvalid: false,
    startLocation: {},
  }

  createTrip = () => {
    const { canCreate, tripId, name, startDate, startLocation, } = this.state
    if (canCreate) {
      // create trip
      this.props.actions.createTrip({
        tripId,
        tripData: {
          name,
          events: [
            {
              id: uuid(),
              name: startLocation.name,
              lat: startLocation.lat,
              lng: startLocation.lng,
              start: true,
              depart: startDate,
            },
          ],
        },
      })
      // navigate to this trip
      this.props.actions.navEditTrip({ tripId, })
    }
  }

  updateTripData = ({ property, value, }) => {
    const newState = { ...this.state, }
    newState[property] = value
    this.validateState(newState)
  }

  validateState = (newState) => {
    const validatedState = { ...newState, }
    validatedState.canCreate = true
    validatedState.tripId = tripIdFromName(validatedState.name)
    // check that trip name is not already in use
    validatedState.nameAlreadyInUse = !!(
      this.props.existingTripIds.indexOf(validatedState.tripId) > -1
    )
    // HACK check that date format is valid
    validatedState.startDateInvalid = true
    if (
      validatedState.startDate.length === 10 &&
      validatedState.startDate[4] === '-' &&
      validatedState.startDate[7] === '-'
    ) {
      validatedState.startDateInvalid = false
    }
    // set overall can create status
    if (
      !validatedState.name ||
      !validatedState.startDate ||
      validatedState.nameAlreadyInUse ||
      !validatedState.startDate ||
      validatedState.startDateInvalid ||
      !validatedState.startLocation.name ||
      !validatedState.startLocation.lat ||
      !validatedState.startLocation.lng
    ) {
      validatedState.canCreate = false
    }
    this.setState(validatedState)
  }

  render() {
    const { updateTripData, createTrip, } = this
    const {
      name,
      startDate,
      canCreate,
      nameAlreadyInUse,
      startLocation,
    } = this.state

    return (
      <div>
        <AddTrip
          name={name}
          nameAlreadyInUse={nameAlreadyInUse}
          startDate={startDate}
          updateTripData={updateTripData}
          canCreate={canCreate}
          startLocation={startLocation}
          createTrip={createTrip}
        />
      </div>
    )
  }
}

export default AddTripScene



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripScene/AddTripScene/component.js